import React from 'react';
import get from 'lodash/get';
import MinimalDumbo from '../MinimalDumbo';
import { getFeature } from '../../../DaEditorWrapper/Features/helper';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features';
import s from './Commission.scss';
export function getFirstExample(_a) {
    var commission = _a.commission, textContent = _a.textContent;
    if (!commission) {
        return;
    }
    if (textContent && textContent.html.type === 'draft') {
        var first = getFeature(FIRST_IMAGE_FEATURE, textContent.html.features);
        return first && first.data && first.data.deviation;
    }
    return commission && commission.examples && commission.examples[0];
}
var Commission = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, ariaHidden = _a["aria-hidden"];
    var example = get(deviation, 'coverImage') || getFirstExample(deviation);
    if (!example) {
        return (React.createElement("div", { style: { width: width, height: height }, className: s['default-background'] }));
    }
    return (React.createElement(MinimalDumbo, { deviation: example, width: width, height: height, "aria-hidden": ariaHidden }));
};
export default Commission;
//# sourceMappingURL=Commission.js.map